import React, { useState } from 'react'
import { ModalWrapper } from '../../../../../../components'
import './Student.css'
import { Typography } from '@mui/material'
import { Manual } from '../../../../../../assets/icons'
import StudentForm from '../component/StudentForm'
// import { useDispatch } from 'react-redux'
// import { setOpenImport } from '../../../../../../redux/globalSlice'

const StudentPopUp = ({ open, handleClose, customRole, userSchoolId }) => {
  // const dispatch = useDispatch()
  const [addManual, setAddManual] = useState(false)
  const [success, setsuccess] = React.useState(false)
  // const [fileName, setFileName] = useState('')
  // const fileInputRef = React.useRef(null)

  // const handleChooseFileClick = () => {
  //   fileInputRef.current.click()
  // }

  // const handleFileChange = (event) => {
  //   const selectedFile = event.target.files[0]
  //   setFileName(selectedFile?.name)
  // }

  const handleFormClose = () => {
    handleClose()
    setAddManual(false)
  }

  return (
    <ModalWrapper open={open} handleClose={handleClose} title={'Add Student'} adminAdd={success}>
      {!addManual && (
        <div>
          <div style={{ display: 'flex', gap: '20px' }}>
            {/* <div className="choose-method" onClick={() => dispatch(setOpenImport(true))}>
              <img src={CSV} alt="" />
              <Typography fontSize={'18px'} fontWeight={700}>
                Import CSV
              </Typography>
              <Typography>You can import students file to quick add.</Typography>
              <Typography>{fileName}</Typography>
              <label htmlFor="fileInput" className="file-input-label">
                <input
                  type="file"
                  id="fileInput"
                  accept=".csv, .xlsx, .xls"
                  className="input-image"
                  ref={fileInputRef}
                  onChange={handleFileChange}
                  style={{ display: 'none' }}
                />
              </label>
            </div> */}
            <div className="choose-method" onClick={() => setAddManual(true)}>
              <img src={Manual} alt="" />
              <Typography fontSize={'18px'} fontWeight={700}>
                Add Manual
              </Typography>
              <Typography>You can add student manually by fill the form</Typography>
            </div>
          </div>
        </div>
      )}
      {/* {addManual && (
      
      )} */}
    </ModalWrapper>
  )
}

export default StudentPopUp
